import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  FormControl,
  NativeSelect,
  InputBase,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { palette, useStylesGlobal } from "configurations/styles/theme";
import { useStylesApp } from "hooks/useStyles";
import {
  condiVehiculo,
  usVehiculo,
  tipVehiculo,
  tipPintura,
  tipCombustible,
  modalidadVenta,
} from "../../../Forms/typeVoucher";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginBottom: "0.5%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightRegular,
    color: palette.primary.menuHeader,
  },
  accordionSumary: {
    backgroundColor: palette.primary.light,
  },
  margin: {
    margin: theme.spacing(0),
    width: "100%",
    marginBottom: "1%",
  },
}));

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(0),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}))(InputBase);

const NewVehicle = ({
  detalleVehiculo,
  setDetalleVehiculo,
  errors,
  open,
  setOpen,
  dataVehiculo,
  setDataVehiculo,
}) => {
  //export default function SearcVoucher({ update, setUpdate, requestConfigSeacrh, setfoundVouchers }) {
  const classes = useStyles();
  const classesGlobal = useStylesGlobal();
  const classesApp = useStylesApp();
  const handleChange = (event) => {
    setDetalleVehiculo({
      ...detalleVehiculo,
      [event.target.name]: event.target.value,
    });
  };

  const handleClickOpen = () => {
    if (dataVehiculo != null) {
      setDetalleVehiculo(dataVehiculo);
    }
    if (open) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  return (
    <div className={classes.root}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          onClick={handleClickOpen}
        >
          <label className={classesGlobal.titleCard}>Vehículo nuevo: </label>
          <label className={classesGlobal.click}>
            <label> </label> (Clic Aquí)
          </label>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <label>Modalidad Operación de Venta:</label>{" "}
              <font color={palette.error.main}>*</font>
            </Grid>
            <Grid item xs={12} md={6} className={classes.divInput}>
              <FormControl className={classesGlobal.select}>
                <NativeSelect
                  value={detalleVehiculo.modalidadOperacionVenta}
                  name="modalidadOperacionVenta"
                  onChange={handleChange}
                  input={<BootstrapInput />}
                >
                  <option aria-label="None" value="">
                    --Seleccione--
                  </option>
                  {modalidadVenta.map((element) => (
                    <option key={element.CODIGO} value={element.CODIGO}>
                      {element.NOMBRE}
                    </option>
                  ))}
                </NativeSelect>
              </FormControl>
              {errors.modalidadOperacionVenta ? (
                <p className={classesApp.errorLetters}>
                  {errors.modalidadOperacionVenta}
                </p>
              ) : null}
            </Grid>

            <Grid item xs={12} md={6}>
              <label>Modalidad Operación de Venta no listada:</label>
            </Grid>
            <Grid item xs={12} md={6}>
              <input
                type="string"
                className="form-control"
                name="operacionNoListada"
                value={detalleVehiculo.operacionNoListada}
                onChange={handleChange}
              />
              {errors.operacionNoListada ? (
                <p className={classesApp.errorLetters}>
                  {errors.operacionNoListada}
                </p>
              ) : null}
            </Grid>

            <Grid item xs={12} md={6}>
              <label>Descripción del color del Vehículo:</label>
            </Grid>
            <Grid item xs={12} md={6}>
              <input
                type="string"
                className="form-control"
                name="descripcionColor"
                value={detalleVehiculo.descripcionColor}
                onChange={handleChange}
              />
              {errors.descripcionColor ? (
                <p className={classesApp.errorLetters}>
                  {errors.descripcionColor}
                </p>
              ) : null}
            </Grid>

            <Grid item xs={12} md={6}>
              <label>Tipo de Combustible:</label>{" "}
              <font color={palette.error.main}>*</font>
            </Grid>
            <Grid item xs={12} md={6} className={classes.divInput}>
              <FormControl className={classesGlobal.select}>
                <NativeSelect
                  value={detalleVehiculo.tipoCombustible}
                  name="tipoCombustible"
                  onChange={handleChange}
                  input={<BootstrapInput />}
                >
                  <option aria-label="None" value="">
                    --Seleccione--
                  </option>
                  {tipCombustible.map((element) => (
                    <option key={element.CODIGO} value={element.CODIGO}>
                      {element.NOMBRE}
                    </option>
                  ))}
                </NativeSelect>
              </FormControl>
              {errors.tipoCombustible ? (
                <p className={classesApp.errorLetters}>
                  {errors.tipoCombustible}
                </p>
              ) : null}
            </Grid>

            <Grid item xs={12} md={6}>
              <label>Tipo Combustible no Listado:</label>
            </Grid>
            <Grid item xs={12} md={6}>
              <input
                type="string"
                className="form-control"
                name="tipoCombustibleNoListado"
                value={detalleVehiculo.tipoCombustibleNoListado}
                onChange={handleChange}
              />
              {errors.tipoCombustibleNoListado ? (
                <p className={classesApp.errorLetters}>
                  {errors.tipoCombustibleNoListado}
                </p>
              ) : null}
            </Grid>

            <Grid item xs={12} md={6}>
              <label>Capacidad Máxima de Tracción:</label>
            </Grid>
            <Grid item xs={12} md={6}>
              <input
                type="string"
                className="form-control"
                name="capacidadTraccion"
                value={detalleVehiculo.capacidadTraccion}
                onChange={handleChange}
              />
              {errors.capacidadTraccion ? (
                <p className={classesApp.errorLetters}>
                  {errors.capacidadTraccion}
                </p>
              ) : null}
            </Grid>

            <Grid item xs={12} md={3}>
              <label>Número del Motor:</label>{" "}
              <font color={palette.error.main}>*</font>
            </Grid>
            <Grid item xs={12} md={3}>
              <input
                type="string"
                className="form-control"
                name="numeroMotor"
                value={detalleVehiculo.numeroMotor}
                onChange={handleChange}
              />
              {errors.numeroMotor ? (
                <p className={classesApp.errorLetters}>{errors.numeroMotor}</p>
              ) : null}
            </Grid>

            <Grid item xs={12} md={3}>
              <label>Chasis del Vehículo:</label>{" "}
              <font color={palette.error.main}>*</font>
            </Grid>
            <Grid item xs={12} md={3}>
              <input
                type="string"
                className="form-control"
                name="chasis"
                value={detalleVehiculo.chasis}
                onChange={handleChange}
              />
              {errors.chasis ? (
                <p className={classesApp.errorLetters}>{errors.chasis}</p>
              ) : null}
            </Grid>

            <Grid item xs={12} md={3}>
              <label>Color del Vehículo:</label>{" "}
              <font color={palette.error.main}>*</font>
            </Grid>
            <Grid item xs={12} md={3}>
              <input
                type="string"
                className="form-control"
                name="color"
                value={detalleVehiculo.color}
                onChange={handleChange}
              />
              {errors.color ? (
                <p className={classesApp.errorLetters}>{errors.color}</p>
              ) : null}
            </Grid>

            <Grid item xs={12} md={3}>
              <label>Potencia del motor (CV):</label>
            </Grid>
            <Grid item xs={12} md={3}>
              <input
                type="string"
                className="form-control"
                name="potenciaMotor"
                value={detalleVehiculo.potenciaMotor}
                onChange={handleChange}
              />
              {errors.potenciaMotor ? (
                <p className={classesApp.errorLetters}>
                  {errors.potenciaMotor}
                </p>
              ) : null}
            </Grid>

            <Grid item xs={12} md={3}>
              <label>Capacidad del Motor:</label>
            </Grid>
            <Grid item xs={12} md={3}>
              <input
                type="string"
                className="form-control"
                name="capacidadMotor"
                value={detalleVehiculo.capacidadMotor}
                onChange={handleChange}
              />
              {errors.capacidadMotor ? (
                <p className={classesApp.errorLetters}>
                  {errors.capacidadMotor}
                </p>
              ) : null}
            </Grid>

            <Grid item xs={12} md={3}>
              <label>Peso Neto (Tn):</label>
            </Grid>
            <Grid item xs={12} md={3}>
              <input
                type="string"
                className="form-control"
                name="pesoNeto"
                value={detalleVehiculo.pesoNeto}
                onChange={handleChange}
              />
              {errors.pesoNeto ? (
                <p className={classesApp.errorLetters}>{errors.pesoNeto}</p>
              ) : null}
            </Grid>

            <Grid item xs={12} md={3}>
              <label>Peso Bruto:</label>
            </Grid>
            <Grid item xs={12} md={3}>
              <input
                type="string"
                className="form-control"
                name="pesoBruto"
                value={detalleVehiculo.pesoBruto}
                onChange={handleChange}
              />
              {errors.pesoBruto ? (
                <p className={classesApp.errorLetters}>{errors.pesoBruto}</p>
              ) : null}
            </Grid>

            <Grid item xs={12} md={3}>
              <label>Distancia entre Ejes:</label>
            </Grid>
            <Grid item xs={12} md={3}>
              <input
                type="string"
                className="form-control"
                name="distanciaEjes"
                value={detalleVehiculo.distanciaEjes}
                onChange={handleChange}
              />
              {errors.distanciaEjes ? (
                <p className={classesApp.errorLetters}>
                  {errors.distanciaEjes}
                </p>
              ) : null}
            </Grid>

            <Grid item xs={12} md={3}>
              <label>Año del modelo de Fabricación:</label>
            </Grid>
            <Grid item xs={12} md={3}>
              <input
                type="string"
                className="form-control"
                name="anioModeloFabricacion"
                value={detalleVehiculo.anioModeloFabricacion}
                onChange={handleChange}
              />
              {errors.anioModeloFabricacion ? (
                <p className={classesApp.errorLetters}>
                  {errors.anioModeloFabricacion}
                </p>
              ) : null}
            </Grid>

            <Grid item xs={12} md={3}>
              <label>Año de Fabricación:</label>
            </Grid>
            <Grid item xs={12} md={3}>
              <input
                type="string"
                className="form-control"
                name="anioFabricacion"
                value={detalleVehiculo.anioFabricacion}
                onChange={handleChange}
              />
              {errors.anioFabricacion ? (
                <p className={classesApp.errorLetters}>
                  {errors.anioFabricacion}
                </p>
              ) : null}
            </Grid>

            <Grid item xs={12} md={3}>
              <label>Tipo de Pintura:</label>
            </Grid>
            <Grid item xs={12} md={3} className={classes.divInput}>
              <FormControl className={classesGlobal.select}>
                <NativeSelect
                  value={detalleVehiculo.tipoPintura}
                  name="tipoPintura"
                  onChange={handleChange}
                  input={<BootstrapInput />}
                >
                  <option aria-label="None" value="">
                    --Seleccione--
                  </option>
                  {tipPintura.map((element) => (
                    <option key={element.CODIGO} value={element.CODIGO}>
                      {element.NOMBRE}
                    </option>
                  ))}
                </NativeSelect>
              </FormControl>
              {errors.tipoPintura ? (
                <p className={classesApp.errorLetters}>{errors.tipoPintura}</p>
              ) : null}
            </Grid>

            <Grid item xs={12} md={3}>
              <label>Tipo de Pintura no listada:</label>
            </Grid>
            <Grid item xs={12} md={3}>
              <input
                type="string"
                className="form-control"
                name="tipoPinturaNoListado"
                value={detalleVehiculo.tipoPinturaNoListado}
                onChange={handleChange}
              />
              {errors.tipoPinturaNoListado ? (
                <p className={classesApp.errorLetters}>
                  {errors.tipoPinturaNoListado}
                </p>
              ) : null}
            </Grid>

            <Grid item xs={12} md={3}>
              <label>Tipo del Vehículo:</label>{" "}
              <font color={palette.error.main}>*</font>
            </Grid>
            <Grid item xs={12} md={3} className={classes.divInput}>
              <FormControl className={classesGlobal.select}>
                <NativeSelect
                  value={detalleVehiculo.tipoVehiculo}
                  name="tipoVehiculo"
                  onChange={handleChange}
                  input={<BootstrapInput />}
                >
                  <option aria-label="None" value="">
                    --Seleccione--
                  </option>
                  {tipVehiculo.map((element) => (
                    <option key={element.CODIGO} value={element.CODIGO}>
                      {element.NOMBRE}
                    </option>
                  ))}
                </NativeSelect>
              </FormControl>
              {errors.tipoVehiculo ? (
                <p className={classesApp.errorLetters}>{errors.tipoVehiculo}</p>
              ) : null}
            </Grid>

            <Grid item xs={12} md={3}>
              <label>Uso del Vehículo:</label>{" "}
              <font color={palette.error.main}>*</font>
            </Grid>
            <Grid item xs={12} md={3} className={classes.divInput}>
              <FormControl className={classesGlobal.select}>
                <NativeSelect
                  value={detalleVehiculo.usoVehiculo}
                  name="usoVehiculo"
                  onChange={handleChange}
                  input={<BootstrapInput />}
                >
                  <option aria-label="None" value="">
                    --Seleccione--
                  </option>
                  {usVehiculo.map((element) => (
                    <option key={element.CODIGO} value={element.CODIGO}>
                      {element.NOMBRE}
                    </option>
                  ))}
                </NativeSelect>
              </FormControl>
              {errors.usoVehiculo ? (
                <p className={classesApp.errorLetters}>{errors.usoVehiculo}</p>
              ) : null}
            </Grid>

            <Grid item xs={12} md={3}>
              <label>Condición del Vehículo:</label>
            </Grid>
            <Grid item xs={12} md={3} className={classes.divInput}>
              <FormControl className={classesGlobal.select}>
                <NativeSelect
                  value={detalleVehiculo.condicionVehiculo}
                  name="condicionVehiculo"
                  onChange={handleChange}
                  input={<BootstrapInput />}
                >
                  <option aria-label="None" value="">
                    --Seleccione--
                  </option>
                  {condiVehiculo.map((element) => (
                    <option key={element.CODIGO} value={element.CODIGO}>
                      {element.NOMBRE}
                    </option>
                  ))}
                </NativeSelect>
              </FormControl>
              {errors.condicionVehiculo ? (
                <p className={classesApp.errorLetters}>
                  {errors.condicionVehiculo}
                </p>
              ) : null}
            </Grid>

            <Grid item xs={12} md={3}>
              <label>Capacidad máxima de pasajeros:</label>
            </Grid>
            <Grid item xs={12} md={3}>
              <input
                type="string"
                className="form-control"
                name="capacidadMaxima"
                value={detalleVehiculo.capacidadMaxima}
                onChange={handleChange}
              />
              {errors.capacidadMaxima ? (
                <p className={classesApp.errorLetters}>
                  {errors.capacidadMaxima}
                </p>
              ) : null}
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default NewVehicle;
